import { render } from "./LogisticsAndWareGainAccess.vue?vue&type=template&id=b8975d8c"
import script from "./LogisticsAndWareGainAccess.vue?vue&type=script&lang=js"
export * from "./LogisticsAndWareGainAccess.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__